import React, {useState, useEffect, useCallback} from 'react';
import {
  BrowserRouter as Router, Routes, Route,
  Navigate, Outlet,
} from 'react-router-dom';
import Register from './Register';
import Home from './Home';
import Profile from './Profile';
import Redeem from './Redeem';
import Logout from './Logout';
import Receipt from './Receipt';
import './styles.css';
import tokenManager from './TokenManager';
import axios from 'axios';
import Loader from './components/Loader';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Home Page.
  */

// eslint-disable-next-line require-jsdoc
function App() {
  const [isloading, setisLoading] = useState(true);

  useEffect(async () => {
    await verifyUser();
  }, []);

  const verifyUser = useCallback(async () => {
    await getRefreshToken();
    setisLoading(false);
  }, []);

  const getRefreshToken = async () => {
    await axios.post(` https://blooming-springs-86289.herokuapp.com/api/login/refresh`, {}, {
      withCredentials: true,
    }).then(async (response) => {
      if (response.status == 200) {
        const {token, memberId} = response.data;
        // console.log(response.data);
        tokenManager.setItems(token, memberId);

        axios.defaults.headers.common = {
          'Authorization': `bearer ${response.data.token}`,
        };
        setTimeout(getRefreshToken, 3 * 60 * 1000 - 3);
      }
    })
        .catch((error) => console.log(error));
  };
  return (
    <>
      {isloading ? <Loader /> : <RoutesComponent />}
    </>
  );
}
/**
 * Authentication Component.
 * @return {html} Page of Outlet.
 */
function RequireAuth() {
  if (!tokenManager.getToken()) return <Navigate to="/" />;
  return <Outlet />;
}

/**
 * Route Component.
 * @return {html} Page of Route.
 */
function RoutesComponent() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Logout />} />
        <Route path='/register' element={<Register />} />
        <Route element={<RequireAuth />}>
          <Route path='/home' element={<Home />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/redeem' element={<Redeem />} />
          <Route path='/receipt' element={<Receipt />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
